import React from 'react'
import { Container, Nav, NavDropdown, Navbar } from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from '../api/axios';
import useAuth, { useValidateSubscriptionState } from '../hooks/useAuth';
import useProps from '../hooks/useProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faExternalLinkAlt, faLayerGroup, faSignOutAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { ENDPOINT_ACCOUNT_SIGN_OUT } from '../Config';
import useEventCtx from '../hooks/useEventCtx';

const Header = () => {
    const { groupId } = useParams();
    const { auth, setAuth } = useAuth();
    const isValidSubscriptionState = useValidateSubscriptionState();
    const { event } = useEventCtx();
    const { props } = useProps();
    const location = useLocation();
    const navigate = useNavigate();
    const logout = async () => {
        // if used in more components, this should be in context 
        // axios to /logout endpoint 
        await axios.get(ENDPOINT_ACCOUNT_SIGN_OUT, {
            withCredentials: true
        });
        setAuth({});
        navigate('/');
        window.location.reload(true);
    }
    return (
        <header>
            <Navbar bg="light" variant="light" className="header-navbar">
                <Container fluid className="align-items-stretch">
                    <Navbar.Brand as={Link} to="/"><img src="/assets/images/logo-v2.1.png" alt="Gather Voices" /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className=" align-items--stretch">
                        <Nav className="me-auto h-100" activeKey={location.pathname}>
                            {auth?.account && groupId &&
                                <>
                                    <Nav.Link as={Link} to={`/group/${groupId}/frame`} eventKey={`/group/${groupId}/frame`} className="d-flex align-items-center"><span>Setup Video Branding</span></Nav.Link>
                                    {event?.frameConfigured &&
                                        <>
                                            <Nav.Link as={Link} to={`/group/${groupId}/invite`} eventKey={`/group/${groupId}/invite`} disabled={!auth?.account} className="d-flex align-items-center"><span>Invitation & Gallery Setup</span></Nav.Link>
                                            <Nav.Link as={Link} to={`/group/${groupId}/speakers`} eventKey={`/group/${groupId}/speakers`} disabled={!auth?.account} className="d-flex align-items-center"><span>{props.speaker}s</span></Nav.Link>
                                            <Nav.Link as={Link} to={`/group/${groupId}/impact`} eventKey={`/group/${groupId}/impact`} disabled={!auth?.account} className="d-flex align-items-center"><span>Reports</span></Nav.Link>
                                        </>
                                    }
                                </>
                            }
                        </Nav>
                        {
                            auth?.account ?
                                <>
                                    <Navbar.Text className='me-3'>
                                        Welcome {auth.account.FirstName}!
                                    </Navbar.Text>
                                    <NavDropdown title={<FontAwesomeIcon icon={faUserCircle} size='lg' />} id="account-dropdown" align="end">
                                        {isValidSubscriptionState &&
                                            <>
                                                <NavDropdown.Item as={Link} to="/"><FontAwesomeIcon icon={faLayerGroup} fixedWidth /> Campaigns</NavDropdown.Item>
                                                {auth.account.Role !== 'SUPER_ADMIN' &&
                                                    <NavDropdown.Item as={Link} to="/account"><FontAwesomeIcon icon={faUser} fixedWidth /> My Account</NavDropdown.Item>
                                                }
                                                <NavDropdown.Item as={Link} to="/billing-portal" target='_blank'><FontAwesomeIcon icon={faDollarSign} fixedWidth /> My Billing Center <FontAwesomeIcon fixedWidth className='ms-1 small text-muted' icon={faExternalLinkAlt} /></NavDropdown.Item>
                                            </>
                                        }
                                        <NavDropdown.Item onClick={logout}><FontAwesomeIcon icon={faSignOutAlt} fixedWidth /> Sign Out</NavDropdown.Item>
                                    </NavDropdown>
                                </>
                                :
                                <Nav.Link as={Link} to="/login">Sign in</Nav.Link>
                        }
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default Header
